<!-- 
 * @Autor: Sakurag1_LSJ
 * @LastEditors: Lvshijie
-->
<template>
  <div class="tool">
    <h1 id="modelSelect">Please Select species</h1>
    <div class="gallery-style-one-area default-padding-top">
      <div class="">
        <div class="row justify-content-md-center">
          <div class="col-xl-3 Colcenter">
            <div class="Colcenterin">
              <div
                class="gallery-style-one cursor"
                @click="$router.push('/Expression/maize')"
              >
                <img
                  class="hvr-grow-shadow imgindex"
                  src="../../assets/picture/8.jpg"
                  alt="Thumb"
                />
                <div class="overlay">
                  <!-- <span>PPI/PDI</span> -->
                  <h4>
                    <a
                      style="
                        pointer-events: none;
                        color: #ffffff;
                        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
                      "
                      >Maize</a
                    >
                  </h4>
                </div>
              </div>
              <div>
                <p class="detailP">
                  Prediction of Chromatin Interaction in PPIs and PDIs Modes Based on Maize B73.
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 Colcenter">
            <div class="Colcenterin">
              <div
                class="gallery-style-one cursor"
                @click="$router.push('/Expression/rice')"
              >
                <img
                  class="hvr-grow-shadow imgindex"
                  src="../../assets/picture/shuidao.jpg"
                  alt="Thumb"
                />
                <div class="overlay">
                  <!-- <span>zs97/mh63</span> -->
                  <h4>
                    <a style="pointer-events: none; color: #ffffff">Rice</a>
                  </h4>
                </div>
              </div>
              <div>
                <p class="detailP">
                  Prediction of Chromatin Interactions in PPIs Mode Based on Rice MH63 and ZS97.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center">
          <div class="col-xl-3 Colcenter">
            <div class="Colcenterin">
              <div
                class="gallery-style-one cursor"
                @click="$router.push('/Expression/cotton')"
              >
                <img
                  class="hvr-grow-shadow imgindex"
                  src="../../assets/picture/mianhua.jpg"
                  alt="Thumb"
                />
                <div class="overlay" style="">
                  <!-- <span>A2/B1/C1/D5...</span> -->
                  <h4>
                    <a
                      style="
                        pointer-events: none;
                        color: #ffffff;
                        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
                      "
                      >Cotton</a
                    >
                  </h4>
                </div>
              </div>
              <div>
                <p class="detailP">
                  Prediction of Chromatin Interaction in PPIs and PDIs Modes Based on Eight Cotton Materials.
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 Colcenter">
            <div class="Colcenterin">
              <div
                class="gallery-style-one cursor"
                id="ex2"
                @click="$router.push('/Expression/wheat')"
              >
                <img
                  class="hvr-grow-shadow imgindex"
                  src="../../assets/picture/xiaomai.jpg"
                  alt="Thumb"
                />
                <div class="overlay">
                  <!-- <span>TPM</span> -->
                  <h4>
                    <a
                      style="
                        pointer-events: none;
                        color: #ffffff;
                        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
                      "
                      >Wheat</a
                    >
                  </h4>
                </div>
              </div>
              <div>
                <p class="detailP">
                  Prediction of Chromatin Interaction under PPIs and PDIs Modes Based on Chinese Spring Wheat.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Back></Back>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "index",
  components: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style scoped src="../../assets/css/bootstrap.min.css"></style>
<!-- <style scoped src='../../assets/css/style.css'></style> -->

<style scoped>
.tool {
  width: 80%;
  margin: 0 auto;
  display: flex; /* 使用flex布局 */
  flex-direction: column; /* 子元素垂直排列 */
  align-items: center; /* 子元素在交叉轴上居中（水平居中） */
  justify-content: center; /* 子元素在主轴上居中（垂直居中） */
  overflow: hidden; /* 隐藏溢出的内容 */
}
#modelSelect {
  text-align: center;
  font-weight: bold;
  color: #000;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* 黑色阴影 */
  margin: 50px;
}
.detailP {
  font-size: 22px;
  font-weight: bolder;
  font-family: "Times New Roman";
  color: #000;
  /* text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); 黑色阴影 */
  width: 470px;

  text-align: justify;
  text-justify: inter-word; 

}
.hvr-grow-shadow {
  /* width: 400px !important;
  height: 320px !important; */
  display: block;
  margin-left: auto;
  margin-right: auto;
  /* 为图片添加宽度和高度可以在需要时调整图片大小 */
  /* width: 100%;
  height: auto; */
  width: 300px;
  height: 300px;
}
.col-xl-3 {
  margin: 120px; /* 为上下左右添加间距 */
  margin-top: 20px; /* 为上边添加间距 */
  margin-bottom: 0px; /* 为下边添加间距 */
}
:root {
  --font-default: "Manrope", sans-serif;
  --font-secondary: "Handlee", cursive;
  --fontawesome: "Font Awesome 5 Pro";
  --black: #000000;
  --dark: #1f4e3d;
  --white: #ffffff;
  --color-primary: #49a760;
  --color-secondary: #f7c35f;
  --color-heading: #04000b;
  --color-paragraph: #787878;
  --box-shadow-primary: -1px 3px 10px 0 rgba(0, 0, 0, 0.6);
  --box-shadow-secondary: 0 10px 30px 0 rgba(44, 130, 237, 0.4);
  --box-shadow-regular: 0px 2px 12px 0px #e7e7e7;
  --bg-gray: #eff2f5;
  --bg-gradient: linear-gradient(
    97deg,
    #49a760 50%,
    rgba(252, 197, 27, 1) 100%
  );
}
.hvr-grow-shadow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow, transform;
  transition-property: box-shadow, transform;
}
.hvr-grow-shadow:hover,
.hvr-grow-shadow:focus,
.hvr-grow-shadow:active {
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.services-style-two:nth-child(1) .services-style-two-item,
.services-style-two-item:hover {
  border: 1px solid #1f4e3d;
}

.gallery-style-one {
    position: relative;
    padding-bottom: 30px;
    overflow: hidden;
}

.gallery-style-one .overlay {
    background: #b29873;
    display: inline-block;
    position: absolute;
    z-index: 1;
    right: 30px;
    bottom: -80px;
    padding: 20px 30px;
    min-width: 65%;
    transition: all 0.35s ease-in-out;
    visibility: hidden;
    opacity: 0;
}

.gallery-style-one:hover .overlay {
    bottom: 0;
    visibility: visible;
    opacity: 1;
}
.Colcenter{
  display: flex;
  justify-content: center;
}
.Colcenterin{
display: flex;
align-items: center;
flex-direction: column;

}

.imgindex{
  border-radius: 5%;
  cursor: pointer;
}
</style>
